import axios from "../../axios.service";
import { TokenService } from "../../storage.service";

class User {

  logout() {
    TokenService.removeCofnig();
    axios.removeHeaders();
  }
}

export default new User();
